import { Button } from "antd";
import React, { useState } from "react";

import { syncFirebaseUser } from "../api";
import { showErrorToast, showSuccessToast } from "@src/appV2/lib/Notifications";

function FirebaseSyncButton({ userId, retrieveUser }) {
  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    setLoading(true);
    const { success, error } = await syncFirebaseUser(userId);
    if (success) {
      showSuccessToast("Mobile login generated");
      retrieveUser();
    } else {
      showErrorToast(error);
    }
    setLoading(false);
  };

  return (
    <Button type="primary" loading={loading} onClick={onClick}>
      Sync Mobile Login
    </Button>
  );
}

export { FirebaseSyncButton };
